import toggleTab from '../../../js/src/__page/verdicalSlider';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		toggleTab();
	},
	loaded() {},
	resized() {
		toggleTab();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
